var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container-fluid",attrs:{"id":"enther-template"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-6 col-md-8 col-sm-10 offset-sm-1 offset-xl-4 offset-lg-3 offset-md-2 enther-wrapper"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }